/** @file Registers an uploaded image (content hash + size) under a slugified, unique ASCII name. */
import { z } from 'zod';
import { slugifyName } from '@pose2d/format/slugifyName';
import { skeletonParts } from '@pose2d/format/doc/schemaParts/skeleton';
import { defineCommand } from '../defineCommand';
import { defineCreate } from '../_shared/defineCreate';

export const command = defineCommand({
  ...defineCreate({
    domain: 'image',
    kind: 'image',
    description: 'Register an uploaded PNG by sha256 and size; the name is slugified to ASCII and made unique (a warning lists renames).',
    schema: skeletonParts.image.extend({ id: z.string().exactOptional(), name: z.string().min(1) }).strict(),
    build(input, ctx) {
      const taken = new Set(ctx.index.byName.get('image')?.keys());
      const raw = input.name.replace(/\.png$/i, '');
      const { name, renamed } = slugifyName(raw, taken, taken.size + 1);
      if (renamed) ctx.warnings.push({ code: 'INFO', message: `image "${raw}" was registered as "${name}"`, params: { from: raw, to: name }, path: 'name' });
      return { name, sha256: input.sha256, w: input.w, h: input.h, ...(input.origin ? { origin: input.origin } : {}) };
    },
  }),
  name: 'image.register',
});
